<template xmlns="http://www.w3.org/1999/html">
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <PageHeader :title="title" :items="items" />
      </div>
    </div>
  </Layout>
</template>

<script>
import http from '@state/http'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
export default {
  name: 'addJvcModal',
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'Search SES',
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'SES JVR Add',
          active: true,
        },
      ],
      districts: [],
      mouzas: [],
      plot_schedules: [],
      validation_errors: {},
      show: false,
      search: {
        district_id: '',
        mouza_id: '',
        plot_schedule_id: '',
      },
      ses_id: '',
      jvrs: '',
    }
  },

  mounted() {
    this.getCodes()
  },

  methods: {
    getCodes() {
      http.get('api/jvc/codes').then((response) => {
        if (!response.error) {
          let data = response.data
          this.districts = data.districts
        }
      })
    },

    getMouzas(districtId) {
      http.get('/api/mouzas/' + districtId).then((response) => {
        this.mouzas = response.data.mouzas
        this.search.mouza_id = ''
        this.search.plot_schedule_id = ''
      })
    },
    getPlotSchedludes(mouzaId) {
      http.get('/api/plot_schedules/' + mouzaId).then((response) => {
        this.plot_schedules = response.data.plot_schedules
        this.search.plot_schedule_id = ''
      })
    },
    searchJvr() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          http.post('api/jvr/search', this.search).then((response) => {
            this.jvrs = response.data.jvr_lists
          })
        }
      })
    },
    addToSes(jvrId) {
      if (jvrId) {
        http
          .post('api/jvr/ses/add', {
            ses_id: this.ses_id,
            jvr_land_id: jvrId,
          })
          .then((response) => {
            this.$bvToast.toast(response.data.message, {
              title: 'Success',
              solid: true,
            })
          })
      }
    },
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.custom-select {
  -webkit-appearance: unset;
}

.vdp-datepicker input {
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ced4da;
  height: 30px;
  padding-left: 15px;
  color: #6b757d;
}

.multiselect__tags {
  border-color: #ced4da;
  border-radius: 3px;
  min-height: 31px;
  padding: 4px 25px 0px 10px;
  margin-bottom: 0;
}

.multiselect__tag {
  margin-bottom: 0px;
}

.multiselect__placeholder {
  margin-bottom: 0px;
}

.multiselect__select {
  height: 31px;
}

.custom-select {
  color: #6c757d !important;
}

.c-required {
  color: red;
}
</style>
